export const REFEICAO = 45;
export const ALIMENTACAO = 46;
export const REFEICAO_PAT = 47;
export const ALIMENTACAO_PAT = 48;
export const MULTIBENEFICIOS = 58;
export const MULTIBENEFICIOS_LIMITE = 58;
export const MULTIBENEFICIOS_SALDO = 57;
export const FROTA = 59;
export const NATAL = 60;
export const CULTURA = 61;
export const MOBILIDADE = 62;
